import { PublicClientApplication } from '@azure/msal-browser'
import { MsalProvider } from '@azure/msal-react'
import { datadogLogs } from '@datadog/browser-logs'
import { useEffect, useState } from 'react'

import {
  AuthFailure,
  AuthInitializationBoundary,
  AuthLoading,
} from './AuthFailure'
import { msalConfig } from './msalConfig'
import { MsalContext } from './MsalContext'

let application: Promise<PublicClientApplication> | undefined

const getApplication = (): Promise<PublicClientApplication> => {
  if (!application) {
    application = Promise.resolve().then(async () => {
      const instance = new PublicClientApplication(msalConfig)
      await instance.initialize()
      return instance
    })
  }
  return application
}

export const AuthProviderWrapper: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [instance, setInstance] = useState<PublicClientApplication | null>(null)
  const [failed, setFailed] = useState(false)

  useEffect(() => {
    let mounted = true
    getApplication().then(
      (client) => {
        if (mounted) setInstance(client)
      },
      (error: unknown) => {
        datadogLogs.logger.error('Authentication initialization failed', {
          error,
        })
        if (mounted) setFailed(true)
      },
    )
    return () => {
      mounted = false
    }
  }, [])

  return (
    <AuthInitializationBoundary>
      {failed ? (
        <AuthFailure />
      ) : instance ? (
        <MsalProvider instance={instance}>
          <MsalContext>{children}</MsalContext>
        </MsalProvider>
      ) : (
        <AuthLoading />
      )}
    </AuthInitializationBoundary>
  )
}
